/*
 * SourceToHome - "Tell us what you need" finder.
 * No libraries. Pure helpers are exported for tests (module.exports).
 * The customer sentence is never stored or sent anywhere except the
 * Shopify predictive-search request (search/suggest.json).
 */
(function (root) {
  'use strict';

  var DUR = { 'the': 1, 'a': 1, 'an': 1, 'my': 1, 'your': 1, 'our': 1, 'i': 1, 'we': 1,
    'you': 1, 'for': 1, 'of': 1, 'to': 1, 'in': 1, 'on': 1, 'at': 1, 'is': 1, 'are': 1,
    'it': 1, 'that': 1, 'this': 1, 'with': 1, 'and': 1, 'or': 1, 'me': 1, 'am': 1,
    'be': 1, 'do': 1, 'does': 1, 'de': 1, 'la': 1, 'el': 1, 'los': 1, 'las': 1, 'un': 1,
    'una': 1, 'mi': 1, 'mis': 1, 'y': 1, 'que': 1, 'se': 1, 'en': 1, 'con': 1, 'por': 1,
    'para': 1, 'al': 1, 'del': 1, 'es': 1,
    // Genel niyet sozcukleri urun turu soylemez (2026-10-14: "dad who loves his car" -> kedi yatagi).
    'need': 1, 'want': 1, 'love': 1, 'loves': 1, 'like': 1, 'likes': 1, 'gift': 1, 'gifts': 1,
    'who': 1, 'his': 1, 'her': 1, 'him': 1, 'some': 1, 'something': 1, 'looking': 1, 'buy': 1,
    'get': 1, 'help': 1, 'new': 1, 'good': 1, 'quiero': 1, 'necesito': 1, 'regalo': 1, 'busco': 1,
    'le': 1, 'su': 1, 'sus': 1, 'gusta': 1, 'encanta': 1 };

  function normalize(value) {
    if (value == null) { return ''; }
    var t = String(value).toLowerCase();
    if (t.normalize) { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    t = t.replace(/[^a-z0-9]+/g, ' ');
    return t.replace(/^\s+|\s+$/g, '');
  }

  function kok(w) {
    if (w.length > 4 && w.slice(-3) === 'ing') { return w.slice(0, -3); }
    if (w.length > 3 && w.slice(-2) === 'es') { return w.slice(0, -2); }
    if (w.length > 2 && w.slice(-1) === 's') { return w.slice(0, -1); }
    return w;
  }

  function sozcukler(value) {
    var parts = normalize(value).split(' ');
    var out = [];
    var i, w;
    for (i = 0; i < parts.length; i++) {
      w = parts[i];
      if (w.length < 2 || DUR[w]) { continue; }
      out.push(kok(w));
    }
    return out;
  }

  function kayitIfadeleri(kayit) {
    var bag = [];
    var sets = [kayit.ifadeler_en, kayit.ifadeler_es];
    var s, arr, i;
    for (s = 0; s < sets.length; s++) {
      arr = sets[s] || [];
      for (i = 0; i < arr.length; i++) { bag.push(arr[i]); }
    }
    if (kayit.arama) { bag.push(kayit.arama); }
    if (kayit.baslik_en) { bag.push(kayit.baslik_en); }
    if (kayit.baslik_es) { bag.push(kayit.baslik_es); }
    return bag;
  }

  function puanla(kayit, kelimeler) {
    if (!kayit || !kelimeler || !kelimeler.length) { return 0; }
    var ifadeler = kayitIfadeleri(kayit);
    var tokenlar = {};
    var i, j, ws, kw, w;
    for (i = 0; i < ifadeler.length; i++) {
      ws = sozcukler(ifadeler[i]);
      for (j = 0; j < ws.length; j++) { tokenlar[ws[j]] = 1; }
    }
    var score = 0;
    for (i = 0; i < kelimeler.length; i++) {
      kw = kelimeler[i];
      if (tokenlar[kw]) { score += 1 + Math.min(kw.length, 8) / 4; }
    }
    var sorgu = kelimeler.join(' ');
    if (!sorgu) { return score; }
    var ek = 0;
    // Ifadenin sorguyu icermesi (ters yon) yalniz 2+ sozcuklu sorguda bonus verir.
    var tersOk = kelimeler.length >= 2;
    for (i = 0; i < ifadeler.length; i++) {
      var ksl = sozcukler(ifadeler[i]);
      // Etkisiz sozcukler atilinca tek sozcuge inen ifade ("something for the car") bonus almaz.
      if (ksl.length < 2) { continue; }
      w = normalize(ifadeler[i]);
      var ks = ksl.join(' ');
      if (w && (sorgu.indexOf(w) !== -1 || (tersOk && w.indexOf(sorgu) !== -1))) {
        ek = Math.max(ek, 6 + w.length / 10);
      }
      if (ks && (sorgu.indexOf(ks) !== -1 || (tersOk && ks.indexOf(sorgu) !== -1))) {
        ek = Math.max(ek, 6 + ks.length / 10);
      }
    }
    return score + ek;
  }

  function enIyi(kayitlar, sorgu, n) {
    var ist = (typeof n === 'number' && n > 0) ? n : 2;
    var out = [];
    if (!kayitlar || !kayitlar.length) { return out; }
    var kelimeler = sozcukler(sorgu);
    if (!kelimeler.length) { return out; }
    var scored = [];
    // Tek kisa sozcuk eslesmesi ("small" -> "small dog") zayif; esik alti dogrudan aramaya duser.
    for (var i = 0; i < kayitlar.length; i++) {
      var sc = puanla(kayitlar[i], kelimeler);
      if (sc >= 3.5) { scored.push({ kayit: kayitlar[i], puan: sc }); }
    }
    scored.sort(function (a, b) { return b.puan - a.puan; });
    for (var k = 0; k < scored.length && k < ist; k++) { out.push(scored[k].kayit); }
    return out;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function aramaAdresi(rootUrl, terim) {
    var base = rootUrl || '/';
    if (base.charAt(base.length - 1) !== '/') { base += '/'; }
    return base + 'search/suggest.json?q=' + encodeURIComponent(terim) +
      '&resources[type]=product&resources[limit]=8';
  }

  var api = {
    normalize: normalize,
    kok: kok,
    sozcukler: sozcukler,
    puanla: puanla,
    enIyi: enIyi,
    escapeHtml: escapeHtml,
    aramaAdresi: aramaAdresi
  };

  root.STHIhtiyac = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }

  if (typeof document === 'undefined') { return; }

  function readConfig() {
    var el = document.getElementById('sth-ih-config');
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function urunListesi(yanit) {
    try {
      var r = yanit.resources.results;
      return (r && r.products) || [];
    } catch (e) { return []; }
  }

  function gorselUrl(urun) {
    var img = urun.featured_image || urun.image;
    if (img && typeof img === 'object') { return img.url || ''; }
    if (typeof img === 'string') { return img; }
    return '';
  }

  function init() {
    var host = document.getElementById('sth-ihtiyac-arama');
    var cfg = readConfig();
    if (!host || !cfg) { return; }

    var labels = cfg.labels || {};
    var collLabels = cfg.collections || {};
    var rootUrl = cfg.rootUrl || '/';
    if (rootUrl.charAt(rootUrl.length - 1) !== '/') { rootUrl += '/'; }

    var form = host.querySelector('[data-sth-ih-form]');
    var input = host.querySelector('[data-sth-ih-input]');
    var resultsBox = host.querySelector('[data-sth-ih-results]');
    var dictPromise = null;
    var busy = false;

    function kacis(s) { return escapeHtml(s); }

    function mesaj(metin) {
      if (!resultsBox) { return; }
      resultsBox.innerHTML = '<p class="sth-ih-muted sth-ih-wide">' + kacis(metin) + '</p>';
    }

    function sozlukGetir() {
      if (!dictPromise) {
        dictPromise = fetch(cfg.dictUrl).then(function (res) {
          if (!res.ok) { throw new Error('dict'); }
          return res.json();
        }).catch(function () { return { kayitlar: [] }; });
      }
      return dictPromise;
    }

    function kartlar(urunler) {
      var html = '';
      for (var i = 0; i < urunler.length; i++) {
        var p = urunler[i];
        var src = gorselUrl(p);
        html += '<div class="sth-ih-card"><a class="sth-ih-card-link" href="' +
          kacis(p.url || '#') + '">';
        if (src) {
          html += '<img class="sth-ih-card-img" src="' + kacis(src) +
            '" loading="lazy" width="360" height="360" alt="' + kacis(p.title || '') + '">';
        }
        html += '<span class="sth-ih-card-title">' + kacis(p.title || '') + '</span>' +
          '<span class="sth-ih-card-price">' + kacis(p.price || '') + '</span></a></div>';
      }
      return html;
    }

    function tumunuGor(bolumHandle, onEk) {
      var ad = collLabels[bolumHandle] || bolumHandle;
      return '<p class="sth-ih-muted sth-ih-wide">' + kacis(onEk || '') +
        ' <a class="sth-ih-link" href="' + kacis(rootUrl + 'collections/' + bolumHandle) +
        '">' + kacis(ad) + '</a></p>';
    }

    function ara(terim) {
      return fetch(aramaAdresi(rootUrl, terim), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (res) {
        if (!res.ok) { throw new Error('search'); }
        return res.json();
      }).then(function (yanit) { return urunListesi(yanit); });
    }

    function goster(urunler, bolumHandle) {
      if (!resultsBox) { return; }
      if (!urunler.length) {
        if (bolumHandle) { resultsBox.innerHTML = tumunuGor(bolumHandle, labels.noResults); }
        else { mesaj(labels.noResults || ''); }
        return;
      }
      var html = kartlar(urunler.slice(0, 8));
      if (bolumHandle) { html += tumunuGor(bolumHandle, labels.seeAll); }
      resultsBox.innerHTML = html;
    }

    function adaylariDene(adaylar, sira) {
      if (sira >= adaylar.length) { return Promise.resolve(false); }
      return ara(adaylar[sira].arama).then(function (urunler) {
        if (urunler.length) { goster(urunler, adaylar[sira].bolum_handle); return true; }
        return adaylariDene(adaylar, sira + 1);
      });
    }

    function calistir(sorgu) {
      mesaj(labels.loading || '');
      sozlukGetir().then(function (dict) {
        var adaylar = enIyi(dict.kayitlar, sorgu, 2);
        // Esleme yoksa: tum cumle yerine anlamli sozcuklerle ara; bos donerse en uzun tek sozcukle dene.
        function yedekAra() {
          var anlamli = normalize(sorgu).split(' ').filter(function (w) { return w.length > 2 && !DUR[w]; });
          var tumu = anlamli.join(' ') || sorgu;
          return ara(tumu).then(function (urunler) {
            if (urunler && urunler.length) { goster(urunler, ''); return; }
            var uzun = anlamli.slice().sort(function (a, b) { return b.length - a.length; })[0];
            if (!uzun || uzun === tumu) { goster(urunler, ''); return; }
            return ara(uzun).then(function (u2) { goster(u2, ''); });
          });
        }
        if (!adaylar.length) { return yedekAra(); }
        return adaylariDene(adaylar, 0).then(function (oldu) {
          if (!oldu) { return yedekAra(); }
        });
      }).catch(function () { mesaj(labels.error || ''); });
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy || !input) { return; }
        var sorgu = (input.value || '').replace(/^\s+|\s+$/g, '');
        if (!sorgu) { mesaj(labels.empty || ''); return; }
        busy = true;
        calistir(sorgu);
        busy = false;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(typeof window !== 'undefined' ? window : this);
